'use strict';

var App = require('app');

var ContactPerson = Backbone.Model.extend({
    url: function () {
        return '/api/v1/devices/' + this.id + '/contactperson';
    },
});

var API = {
    getEntity: function (deviceId) {
        var contactPerson = new ContactPerson({ id: deviceId });
        var defer = $.Deferred();

        contactPerson.fetch({
            success: function (data) {
                defer.resolve(data);
            },
            error: function () {
                defer.resolve(undefined);
            },
        });

        return defer.promise();
    },
};

App.reqres.setHandler('contactperson:model', function (deviceId) {
    return API.getEntity(deviceId);
});

module.exports = ContactPerson;
